<!-- Overlay loading -->
<app-fullscreen-overlay
  [isOverlayLoading]="isOverlayLoading"
></app-fullscreen-overlay>

<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1"
                >{{
                  conclusionOptionCode
                    ? ("createNewOption" | translate)
                    : conclusionAddOptionId
                    ? ("addNewOption" | translate)
                    : ("editOption" | translate)
                }}
                {{ applicationTitle }}
                {{ "conclusionOption" | translate }}</span
              >
            </h3>
          </div>
          <div class="card-body pt-3 pb-4">
            <form [formGroup]="conclusionOptionForm" (ngSubmit)="onSubmit()">
              <div
                *ngIf="!conclusionOptionId"
                class="d-flex align-items-center justify-content-between mb-8"
              >
                <div class="row">
                  <div class="col-md-10">
                    <!-- Conclusion Title -->
                    <div class="row">
                      <!-- English -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (English)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleEng"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Dutch -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (Dutch)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleDutch"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Turkish -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (Turkish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleTurkish"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- French -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (French)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleFrench"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- German -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (German)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleGerman"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Spanish -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (Spanish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleSpanish"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Italian -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (Italian)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleItalian"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Danish -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (Danish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleDanish"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Swedish -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (Swedish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleSwedish"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Norwegian -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{
                            "conclusionTitle" | translate
                          }}
                          (Norwegian)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleNorwegian"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                      <!-- Finnish -->
                      <div *ngIf="!conclusionAddOptionId" class="col-md-3 mb-5">
                        <label for="conclusionTitle" class="form-label"
                          >{{ "conclusionTitle" | translate }} (Finnish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleFinnish"
                          id="conclusionTitle"
                          placeholder="{{ 'conclusionTitle' | translate }}"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    [ngClass]="
                      conclusionAddOptionId
                        ? 'col-md-12 text-start'
                        : 'col-md-2 text-end'
                    "
                  >
                    <!-- Add new option content -->
                    <a
                      (click)="addConclusionOptionContent()"
                      class="btn btn-sm fw-bold btn-primary"
                      >{{ "addNewOption" | translate }}</a
                    >
                  </div>
                </div>
              </div>

              <!-- Conclusion Option Contents -->
              <div formArrayName="conclusionOptionContents">
                <div
                  *ngFor="
                    let content of conclusionOptionContents.controls;
                    let i = index
                  "
                  [formGroupName]="i"
                  class="row align-items-start mb-3"
                >
                  <div class="col-md-10">
                    <div class="row">
                      <!-- Option Title (English) -->
                      <div class="col-md-3">
                        <label for="titleEng{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (English)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleEng"
                          id="titleEng{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (English) -->
                      <div class="col-md-9">
                        <label for="conclusionTextEng{{ i }}" class="form-label"
                          >{{ "conclusionText" | translate }} (English)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextEng"
                          id="conclusionTextEng{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Dutch) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleDutch{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Dutch)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleDutch"
                          id="titleDutch{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Dutch) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextDutch{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Dutch)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextDutch"
                          id="conclusionTextDutch{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Turkish) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleTurkish{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Turkish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleTurkish"
                          id="titleTurkish{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Turkish) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextTurkish{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Turkish)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextTurkish"
                          id="conclusionTextTurkish{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (French) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleFrench{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (French)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleFrench"
                          id="titleFrench{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (French) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextFrench{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (French)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextFrench"
                          id="conclusionTextFrench{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (German) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleGerman{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (German)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleGerman"
                          id="titleGerman{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (German) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextGerman{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (German)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextGerman"
                          id="conclusionTextGerman{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Spanish) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleSpanish{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Spanish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleSpanish"
                          id="titleSpanish{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Spanish) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextSpanish{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Spanish)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextSpanish"
                          id="conclusionTextSpanish{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Italian) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleItalian{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Italian)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleItalian"
                          id="titleItalian{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Italian) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextItalian{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Italian)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextItalian"
                          id="conclusionTextItalian{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Danish) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleDanish{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Danish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleDanish"
                          id="titleDanish{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Danish) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextDanish{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Danish)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextDanish"
                          id="conclusionTextDanish{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Swedish) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleSwedish{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Swedish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleSwedish"
                          id="titleSwedish{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Swedish) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextSwedish{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Swedish)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextSwedish"
                          id="conclusionTextSwedish{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Norwegian) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleNorwegian{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Norwegian)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleNorwegian"
                          id="titleNorwegian{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Norwegian) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextNorwegian{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Norwegian)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextNorwegian"
                          id="conclusionTextNorwegian{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>

                      <!-- Option Title (Finnish) -->
                      <div class="col-md-3 mt-6">
                        <label for="titleFinnish{{ i }}" class="form-label"
                          >{{ "optionTitle" | translate }} (Finnish)</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          formControlName="titleFinnish"
                          id="titleFinnish{{ i }}"
                          placeholder="{{ 'optionTitle' | translate }}"
                        />
                      </div>

                      <!-- Conclusion Text (Finnish) -->
                      <div class="col-md-9 mt-6">
                        <label
                          for="conclusionTextFinnish{{ i }}"
                          class="form-label"
                          >{{ "conclusionText" | translate }} (Finnish)</label
                        >
                        <textarea
                          class="form-control"
                          formControlName="conclusionTextFinnish"
                          id="conclusionTextFinnish{{ i }}"
                          rows="3"
                          placeholder="{{ 'conclusionText' | translate }}"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <!-- Action Buttons -->
                  <div class="col-md-2 align-self-center">
                    <div class="d-flex flex-column gap-2 align-items-center">
                      <label for="">{{ "actions" | translate }}</label>
                      <div class="d-flex align-items-center gap-2">
                        <!-- Delete Content -->
                        <a
                          [title]="'delete' | translate"
                          (click)="removeConclusionOptionContent(i)"
                          class="delete btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 cursor-pointer"
                          ><i class="fa-solid fa-xmark"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Submit Button -->
              <div class="d-flex justify-content-end mt-8 gap-3">
                <button
                  [routerLink]="['/conclusion-options/list']"
                  type="button"
                  class="btn btn-sm btn-secondary cursor-pointer"
                >
                  {{ "cancel" | translate }}
                </button>
                <button
                  type="submit"
                  class="btn btn-sm btn-dark cursor-pointer"
                >
                  {{ "save" | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
